import React from "react";
//material-ui
import { DatePicker } from "@material-ui/pickers";
import { Controller } from "react-hook-form";
function CustomDatePicker(props) {
    const { label, value = null, format = "YYYY-MM-DD", clearable = false, onChange, views, error, validate } = props;
    const handleChange = (date) => {
        if(date) date = date.format(format);
        onChange(date);
    };
    return (<DatePicker format={format} onChange={handleChange} clearable={clearable} required={validate && !!validate.required} clearLabel="清空" label={label} value={value} okLabel="确定" cancelLabel="取消" fullWidth views={views} error={!!error} helperText={error && error.message}/>);
}
export default function HookTimePickerWraper(props) {
    const { name, validate, control, value = null, ...rest } = props;
    return <Controller as={CustomDatePicker} name={name} rules={validate} control={control} defaultValue={value} validate={validate} {...rest}/>;
}
